import React, { PureComponent, Fragment } from 'react'
import {t} from 'helpers/localization'
import Card from '../Card/Card.tsx'
import { Flags } from '../Flag/Flag'
import classNames from 'classnames'
import {Button, CheckboxWithLabel, StepCSSTransitionGroup, Toggle, Spinner} from '@wg/wows-react-uikit'
import uniqueId from 'lodash/uniqueId'
import styles from './CategoryCard.scss'

export type IProps = {
    cssLevel: number,
    isFetching: Boolean,
    banner: string,
    title: string,
    text: string,
    languages: Array<string>,
    isSettingsEnabled: boolean,
    useVoiceChat: boolean,
    updateUseVoiceChat: (useVoiceChat: Boolean) => void,
    modifyLanguageSettings: () => void,
    onFocus: () => void,
    onBlur: () => void,
    onButtonClick: () => void,
}

class CategoryCard extends PureComponent<IProps, any> {

    constructor(props) {
        super(props)

        this.state = {
            isActive: false,
            forceActiveUntil: 0,
        }

        this.modifyLanguageSettings = this.modifyLanguageSettings.bind(this)

        this.onClick = this.onClick.bind(this)
        this.onMouseEnter = this.onMouseEnter.bind(this)
        this.onMouseLeave = this.onMouseLeave.bind(this)

        this.card = React.createRef()
        this.uuid = uniqueId('category_card_')
    }

    modifyLanguageSettings(event) {
        event.stopPropagation()

        this.setState({
            ...this.state,
            forceActiveUntil: new Date().getTime() + 1000,
        }, () => {
            this.props.modifyLanguageSettings()
        })
    }

    onClick(e) {
        this.focus()
    }

    onMouseEnter() {
        this.focus()
        return false
    }

    onMouseLeave() {
        const canLeave = this.state.forceActiveUntil < new Date().getTime()
        if (canLeave)
            this.blur()
        return false
    }

    focus() {
        this.card.current.focus()
        this.setState({...this.state, isActive: true}, () => {
            this.props.onFocus(this.uuid)
        })
    }

    blur() {
        this.card.current.blur()
        this.setState({...this.state, isActive: false}, () => {
            this.props.onBlur(this.uuid)
        })
    }

    render() {
        let settingsContent = []
        if (this.props.isSettingsEnabled && this.state.isActive) {
            let voiceCheckbox = (
                <CheckboxWithLabel
                    isChecked={this.props.useVoiceChat}
                    onChange={this.props.updateUseVoiceChat}
                    labelText={t('Готов использовать голосовой чат')}/>
            )
            if (this.props.isFetching) voiceCheckbox = <span><Spinner />{' ' + t('Сохранение настроек')}</span>


            settingsContent = [
                <StepCSSTransitionGroup key="settings-group" level={2}>
                    <span className={styles.settingsTitle}>{t('Общение')}</span>
                    <div className={styles.settingsInputGroup}>
                        <Flags onClick={(e) => this.modifyLanguageSettings(e)} languages={this.props.languages} maxDisplayCount={4}/>
                        <div className={styles.modifyButton}>
                            <Toggle onClick={(e) => this.modifyLanguageSettings(e)} caption={t('Изменить')}/>
                        </div>
                    </div>
                    <div className={styles.settingsInputGroup}>
                        {voiceCheckbox}
                    </div>
                </StepCSSTransitionGroup>,
            ]
        }
        settingsContent.push(
            <div key={'submit'} className={classNames(styles.settingsInputGroup, styles.settingsInputGroupSubmit)}>
                <Button isLarger isJustified onClick={this.props.onButtonClick}>{t('Подобрать клан')}</Button>
            </div>
        )

        return (
            <StepCSSTransitionGroup level={this.props.cssLevel} className={styles.CSSTransitionGroup}>
                <Card
                    ref={this.card}
                    onClick={this.onClick}
                    onMouseMove={() => false}
                    onMouseEnter={this.onMouseEnter}
                    onMouseLeave={this.onMouseLeave}
                    className={styles.wrapper}>
                    <div className={classNames(styles.banner, styles['banner_' + this.props.banner])} />
                    <span className={styles.title}>{this.props.title}</span>
                    <span className={styles.text}>{this.props.text}</span>
                    <div className={classNames(styles.settings, {[styles.active]: this.state.isActive})}>
                        {settingsContent}
                    </div>
                </Card>
            </StepCSSTransitionGroup>
        )
    }
}

CategoryCard.defaultProps = {
    cssLevel: 1,
    isFetching: false,
    banner: 'no_obligations',
    title: '',
    text: '',
    languages: [],
    isSettingsEnabled: true,
    useVoiceChat: false,
    updateUseVoiceChat: (useVoiceChat: Boolean) => {},
    modifyLanguageSettings: () => {},
    onFocus: (uuid) => {},
    onBlur: (uuid) => {},
    onButtonClick: () => {},
}

export default CategoryCard